export enum OptionStatus {
    NEW = 0,
    ACTIVE = 1,
    HIDDEN = 2,
    ARCHIVED = 3,
}
